import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Progress, Tooltip } from 'antd';
import { formatNumberToShortString } from '../../../helpers/string';
import LoadingIcon from '../../Chat/common/LoadingIcon';
import s from './TemplateMessageDrawer.module.scss';
import { getDirection } from '../../../helpers';
const LimitDashboard = ({ limit, sent, loading }) => {
    const { t, i18n } = useTranslation();
    const dir = i18n.dir(i18n.language) || getDirection();
    const usage = loading && !sent ? 0 : sent;
    const percent = limit > 0 ? Math.round((usage / limit) * 100) : 0;
    return (React.createElement("div", { className: s['template-message__limitContainer'] }, loading ? (React.createElement(LoadingIcon, { additionalStyles: s['template-message__loadingIcon'] })) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s['template-message__limitRow'] },
            React.createElement("div", { className: s['template-message__text'], dir: dir },
                React.createElement(Trans, { i18nKey: "messagesUsedCounter", components: { strong: React.createElement("strong", null) }, values: {
                        usage,
                        limit: formatNumberToShortString(limit)
                    } })),
            React.createElement(Tooltip, { title: t('sendLimitTemplateMenuMessage'), overlayClassName: s['limit-dashboard__tooltip'] },
                React.createElement(InfoCircleOutlined, { className: s['template-message__infoIcon'] }))),
        React.createElement("div", { className: s['template-message__limitRow'] },
            React.createElement(Progress, { percent: percent, status: loading ? 'active' : 'normal', "aria-busy": loading, strokeColor: "#0FB878" // $primary_green
                , className: s['template-message__progressBar'] }))))));
};
export default LimitDashboard;
